module.exports = __webpack_public_path__ + "static/media/map-pin-white-dot-large.d7bf9744.svg";